// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Scalars = require("../../../scalars/Scalars.bs.js");
var PageViews = require("../../PageViews.bs.js");
var AuthSession = require("../../../utils/AuthSession.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var UseWindowSize = require("uikit/hooks/useWindowSize");
var RecordPropertyCreatedEvent_RecordPropertyCreatedEventV5Mutation_graphql = require("../../../__generated__/RecordPropertyCreatedEvent_RecordPropertyCreatedEventV5Mutation_graphql.bs.js");

var convertVariables = RecordPropertyCreatedEvent_RecordPropertyCreatedEventV5Mutation_graphql.Internal.convertVariables;

var convertResponse = RecordPropertyCreatedEvent_RecordPropertyCreatedEventV5Mutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = RecordPropertyCreatedEvent_RecordPropertyCreatedEventV5Mutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, RecordPropertyCreatedEvent_RecordPropertyCreatedEventV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

var use = RescriptRelay_Mutation.useMutation(convertVariables, RecordPropertyCreatedEvent_RecordPropertyCreatedEventV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

var RecordPropertyCreatedEventV5Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function useRecordEvent() {
  var isImpersonated = AuthSession.useIsImpersonated();
  var match = use();
  var mutate = match[0];
  var size = UseWindowSize.useWindowSize();
  return function (propertyId) {
    if (isImpersonated) {
      return ;
    } else {
      mutate({
            input: {
              occurredAt: Scalars.DateTime.fromJsDate(new Date()),
              propertyId: propertyId,
              userAgent: PageViews.userAgent(),
              windowSize: {
                height: size.height,
                width: size.width
              }
            }
          }, undefined, undefined, undefined, undefined, undefined, undefined);
      return ;
    }
  };
}

exports.RecordPropertyCreatedEventV5Mutation = RecordPropertyCreatedEventV5Mutation;
exports.useRecordEvent = useRecordEvent;
/* commitMutation Not a pure module */
